import { LOGUS_CONFIG } from '../config'
import axios from 'axios'

export default {

    /*
        GET     /api/settlements
    */
    getSettlements: function(options){
        return axios.get( LOGUS_CONFIG.API_URL + '/settlements',{
            params:{
                offset:options.offset,
                itemsPerPage:options.itemsPerPage,
                orderBy:options.orderBy,
                orderDirection:options.orderDirection,
                selectedYear:options.selectedYear,
                selectedMonth:options.selectedMonth,
                selectedStatus:options.selectedStatus,
                selectedCourse:options.selectedCourse,
                selectedChild:options.selectedChild,
        }});
    },

    /*
        GET     /api/settlements/courses/
    */
   getSettlementsInCourse: function(options){
        return axios.get( LOGUS_CONFIG.API_URL + '/settlements/courses',{
            params:{
                selectedYear:options.selectedYear,
                selectedMonth:options.selectedMonth,
        }});
    },

     /*
        GET     /api/settlements/unpayed/
    */
   getUnpayedSettlements: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/settlements/unpayed',{
        params:{
            selectedYear:options.selectedYear,
            selectedMonth:options.selectedMonth,
    }});
},

    /*
        GET     /api/settlements/child/
    */
   getSettlementsForChild: function(options){
        return axios.get( LOGUS_CONFIG.API_URL + '/settlements/child',{
            params:{
                child_id:options.child_id,
                document_id:options.document_id,
                type:options.type
        }});
    },

    
    /*
        GET     /api/settlements/bank
    */
   getSettlementsForBank: function(options){
        return axios.get( LOGUS_CONFIG.API_URL + '/settlements/bank',{
            params:{
                bank:options.bank
        }});
    },

    /*
        GET     /api/settlements/generate/
    */
   getGenerateSettlements: function(options){
        return axios.get( LOGUS_CONFIG.API_URL + '/settlements/generate',{
            params:{
                selectedYear:options.selectedYear,
                selectedMonth:options.selectedMonth,
                range:options.range,
                ids:options.ids
        }});
    },

 /*
        GET     /api/settlements/generate/bo
    */
   getGenerateSettlementsBO: function(options){
        return axios.get( LOGUS_CONFIG.API_URL + '/settlements/generate/bo',{
            params:{
                selectedYear:options.selectedYear,
                selectedMonth:options.selectedMonth,
                child_id:options.child_id,
                amount:options.amount,
                hour:options.hour,
                meal:options.meal
        }});
    },

    /*
        GET     /api/settlements/search
    */
   searchSettlements: function(options){
        return axios.get( LOGUS_CONFIG.API_URL + '/settlements/search',{
            params:{
                selectedYear:options.selectedYear,
                selectedMonth:options.selectedMonth,
                selectedStatus:options.selectedStatus,
                selectedCourse:options.selectedCourse,
                selectedChild:options.selectedChild,
                filterableHeaders:options.filterableHeaders,
                q:options.q
        }});
    },

    /*
		GET /api/settlements/{slug}/log
	*/
    getSettlementLog: function( slug ){
		return axios.get( LOGUS_CONFIG.API_URL + '/settlements/' + slug + '/log' );
    },

    /*
		GET /api/settlements/{slug}/notification
	*/
    getSettlementNotificationSend: function( slug ){
		return axios.get( LOGUS_CONFIG.API_URL + '/settlements/' + slug + '/notification' );
    },

    /*
		GET /api/settlements/{slug}/recalculate
	*/
    getSettlementRecalculate: function( slug ){
		return axios.get( LOGUS_CONFIG.API_URL + '/settlements/' + slug + '/recalculate' );
    },

    /*
		DELETE /api/settlements/{slug}/force
	*/
    forceDeleteSettlement: function( slug ){
		return axios.delete( LOGUS_CONFIG.API_URL + '/settlements/' + slug + '/force' );
    },
    
}